
<!--售后详情-->
<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
        <van-cell-group>
            <van-field
                    label="奖励类型"
                    placeholder="请选择积分奖励"
                    :rules="[{ required: true, message: '请选择类型' }]"
                    v-model="formData.type_name"  
                    readonly
                    @click="showTypeSelect"
                    input-align="right"
            />

            <van-field
                    label="内容描述"
                    placeholder="请输入详细的描述"
                    input-align="right"
                    :rules="[{ required: true,message:'请输输入描述'}]" 
                    v-model="formData.note"    
            />
            <van-cell 
                center
                title="相关图片"   
            >
            </van-cell>
    <!--        <PicUploader :fileList="fileList" :limit="9" @uploadSuccess="uploadSuccess"></PicUploader>-->
            <PicUploader :fileList="formData.pics" :limit="9" @imageListChange="imageListChange"
                        :name="'pics'"></PicUploader>
        <p style="text-align:center; padding:20px 0 ;color: #1989fa " @click="download()">全国啦啦操星级俱乐部积分制度.doc下载&gt;&gt;</p>
        </van-cell-group>
 
            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交申请</van-button>
            </div>
        </van-form>

        <van-popup
                v-model="selectShow"
                position="bottom"
        >
            <van-picker
                    show-toolbar
                    title="标题"
                    :columns="columns"
                    @cancel="onCancel"
                    @confirm="onConfirm"
            />
        </van-popup> 

    </div>
</template>
<style scoped>
    .van-field__body input {
        text-align: right;
    }

    .btn {
        padding: 0 15px;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


</style>

<script>
    import { Button ,Field,Popup,Picker,Toast  } from 'vant';
    import PicUploader from '@/components/picker/PicUploader.vue';

    export default {
        components: {
            Button ,
            Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            Toast,
            PicUploader
        },
        data: function () {
            return {
                selectShow:false,
                formValidate: false,
                saveLoading: false,
                loading: false,
                descr: '',
                columns: ['课程相关', '文化相关', '宣传相关', '申办活动', '评优评奖','规章制度'],
                formData:{
                    order_id:0,
                    type_name:'',
                    type:'',
                    note:'',
                    pics:[],
                    // pics:[{"uid":"vc-upload-1677129488455343","url":"https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2023-02-23/1677129488455343.png","name":"【校园大课间推广实施单位授权书】潮州市潮安区沙溪镇实验学校 (1).png","save_name":"h5/2023-02-23/1677129488455343.png"}]
                },
                fileList: []
            }
        },
        filter: {},
        mounted() {
            document.title='售后申请';
            this.getOrderId()
        },
        destroyed() {

        },
        methods: {
            getOrderId() {
                let that = this;
                that.formData.club_id = that.$route.query.id;
                // console.log(that.id)
            },

            uploadSuccess(data) {
                let that = this;
                that.formData.pics = [];
                data.map(pic=> {
                    that.formData.pics.push(pic.url)
                })

                // console.log(that.formData.pics);
            },

            imageListChange(data) {
                console.log('data', data)
                let that = this;
                let name = data.name
                that.formData[name] = data.pic
            },

            showTypeSelect() {
                this.selectShow = true;
            },

            writeDescr() {
                let that = this;
                that.formData.note = that.descr;
                // console.log(that.descr)
            },

            onCancel() {
                this.selectShow = false;
            },

            onConfirm(value, index) {
                let that = this;
                that.formData.type = index + 1;
                that.formData.type_name = value;
                that.selectShow = false;


                console.log(that.formData)
            },

            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                if(that.formData.pics.length==0){
                    Toast.fail('请至少上传一张图片');
                    return ;
                }
                that.saveLoading = true;
                that.$api.post('/api/club/scoreApply', that.formData, (res) => {
                    that.saveLoading = false;

                    // rbLink({
                    //     name:'HuiyiApplyFormStep2',
                    //     query:{
                    //         id: res.data.id
                    //     }
                    // })

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            download(){
                console.log('donwload')
                appEvent({
                    name: 'downloadFile',
                    query: {
                        name:'全国啦啦操星级俱乐部积分制度.doc',
                        url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230223/user-0/20230223/50358b17a6ffcf28081b65a8f6ea89e0.doc',
                    }
                });
            },
 
        }
    }
</script>



// WEBPACK FOOTER //
// ClubScoreApply.vue?4c3b37f8